<template>
    <div class="login-wrap">
        <div class="login-heading">
            <v-img :src="`${publicPath}img/login-banner.png`" :contain=true></v-img>
        </div>
        <div class="login-container">
            <div class="login-content">
                <p class="subtitle dark-color">{{ $t('Views.Signup.message') }}</p>
                <br/>
                <div v-if="loading" class="text-center">
                    <v-progress-circular
                        
                        :size="50"
                        indeterminate
                        color="primary"
                    ></v-progress-circular>
                    <p class="my-4">{{ $t('Views.Signup.loading') }}</p>
                </div>
                <v-form v-else-if="!userIsSaved" action="#" ref="signupForm" @submit.prevent="signup" loading:true>
                        <v-layout row>
                            <v-text-field solo v-model="newUserData.businessName" class="login-text-input" type="text"
                                        :rules="[rules.required]"
                                        :placeholder="$t('Views.Signup.business_name-placeholder')"
                                        @keyup.enter="signup"></v-text-field>
                        </v-layout>
                        <v-layout row>
                            <v-text-field solo v-model="newUserData.username" class="login-text-input" type="text"
                                        :rules="[rules.required, rules.username]"
                                        :placeholder="$t('Views.Signup.username-placeholder')"
                                        @keyup.enter="signup"></v-text-field>
                        </v-layout>
                        <v-layout row>
                            <v-text-field solo v-model="newUserData.email" class="login-text-input" type="email"
                                        :rules="[rules.required, rules.email]"
                                        :placeholder="$t('Views.Signup.email-placeholder')"
                                        @keyup.enter="signup"></v-text-field>
                        </v-layout>
                        <v-layout row>
                            <v-text-field  solo
                                        v-model="newUserData.password" 
                                        class="login-text-input"
                                        :append-icon="pswVisibility ? 'mdi-eye' : 'mdi-eye-off'"
                                        :rules="[rules.required, rules.password_min_lenght]"
                                        :type="pswVisibility ? 'text' : 'password'"
                                        :placeholder="$t('Views.Signup.password-placeholder')"
                                        @click:append="pswVisibility = !pswVisibility"
                                        @keyup.enter="signup"></v-text-field>
                        </v-layout>

                        <v-layout row wrap>
                                <v-flex xs12 sm8 
                                    :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-1': $vuetify.breakpoint.mdAndUp}"
                                    >
                                    <v-select
                                    class="login-text-input"
                                            v-model="newUserData.country"
                                            :rules="[rules.required]"
                                            :items="countries"
                                            item-text="label"
                                            item-value="key"
                                            :label="$t('Views.Signup.countries-placeholder')"
                                            solo
                                        ></v-select>
                                </v-flex>
                                <v-flex xs12 sm4 
                                    :class="{'pl-0': $vuetify.breakpoint.smAndDown, 'pl-1': $vuetify.breakpoint.mdAndUp}"
                                    >
                                    <v-text-field solo v-model="newUserData.zipcode" class="login-text-input" type="text"
                                            :rules="[rules.required]"
                                            :placeholder="$t('Views.Signup.zipcode-placeholder')"
                                            @keyup.enter="signup"></v-text-field>
                                </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-checkbox v-model="newUserData.privacyAccepted" 
                            :rules="[rules.required]" 
                            hide-details
                            color="red" />

                            <div @click="togglePrivacy">
                                <small>
                                    {{ $t('Views.Signup.privacy-label') }}
                                    <a @click.stop="showPrivacy = true" color="red  ">{{ $t('Views.Signup.privacy-link-text') }}</a>
                                </small>
                            </div>
                        </v-layout>
                    
                        <div class="login-actions">
                            <v-btn block class="mx-0 login-btn font-weight-light"
                                color="danger" @click="signup">
                                {{ $t('Views.Signup.register') }}
                            </v-btn>
                        </div>
                        
                </v-form>
                <v-layout v-else>
                    <v-alert
                        :value="true"
                        type="success"
                        >
                        {{ registrationSuccessMessage }}
                    </v-alert>
                </v-layout>

                <p class="login-links">
                    <a class="dark-color small-label" @click="backToLogin">{{ $t('Views.Signup.back-login') }}</a>
                    <span class="link-sepa dark-color small-label"></span>
                    <a class="dark-color small-label" @click="forgotPassword">{{ $t('Views.Login.forgot-password') }}</a>
                </p>

                <v-dialog
                    v-model="showForgotModal"
                    width="600">
                    <material-forgot-password :service="'dashboard'" @close-modal="showForgotModal=false"/>
                </v-dialog>
                <v-snackbar
                        v-model="snackbar.show"
                        :color="snackbar.color"
                        :timeout="snackbar.timeout"
                        top>
                    {{ snackbar.text }}
                </v-snackbar>

                <v-dialog
                        v-model="showPrivacy"
                        width="600">
                    <privacy-text @close-modal="showPrivacy=false"/>
                </v-dialog>
            </div>
            <div class="login-footer" />
        </div>    
    </div>
</template>

<script>
import i18n from '@/i18n'
import httpService from '@/service/httpService'
import {countries} from '@/json-common/countries'
import PrivacyText from '@/components/material/PrivacyText'
import { mapGetters } from 'vuex'
import {publicPath} from "../../vue.config";

export default {
    name: 'signup',
    components: {
        'privacy-text': PrivacyText
    },
    data() {
        return {
            newUserData: {
                username: '',
                email: '',
                password: '',
                portalUser: false,
                businessName: '',
                zipcode: '',
                country: '',
                language: '',
                privacyAccepted: false
            },
            rules: {
                required: v => !!v || i18n.t('Views.Signup.validate_required'),
                acceptance: v => !!v || i18n.t('Views.Signup.validate_acceptance'),
                password_min_lenght: v => v.length >= 8 || i18n.t('Views.Signup.validate_password_lenght'),
                email: v => /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(v) || i18n.t('Views.Signup.validate_email'),
                username: v => /^[a-zA-Z0-9]([.@_](?![.@_])|[a-zA-Z0-9]){2,16}[a-zA-Z0-9]$/i.test(v) || i18n.t('Views.Signup.validate_username'),
            },
            snackbar: {
                show: false,
                color: '',
                timeout: 6000,
                text: ''
            },
            showPrivacy: false,
            showForgotModal: false,
            pswVisibility: false,
            countries: countries,
            userIsSaved: false,
            loading: false,
            registrationSuccessMessage: "",
            publicPath: publicPath
        }
    },
    methods: {
        signup() {
            // signup data
            
            if(this.validateForm()) {
                console.log("Form is valid")
                //prima di inviare l'utente setto la lingua
                this.newUserData.language = this.getLanguage
                console.log(this.newUserData);
                this.loading = true
                httpService.post('/users/', this.newUserData)
                .then(() => {
                    this.registrationSuccessMessage =  this.$t('Views.Signup.form-success');
                    this.userIsSaved = true
                    this.loading = false
                })
                .catch(error => {
                    console.error(error);
                    this.snackbar.text = 'Could not update User'
                    this.snackbar.color = 'error'
                    this.snackbar.show = true
                    this.loading = false
                })

            } else {
                this.snackbar.text = this.$t('Views.Signup.form-invalid')
                this.snackbar.color = 'error'
                this.snackbar.show = true
            }
        },
        forgotPassword() {
            this.showForgotModal = true
        },
        backToLogin() {
            this.$router.push({name: 'Login'})
        },
        togglePrivacy() {
            this.newUserData.privacy_accepted = !this.newUserData.privacy_accepted;
        },
        validateForm () {
            return this.$refs.signupForm.validate();
        }
    },
    computed: {
    ...mapGetters([
      'getLanguage'
    ])
  }
}
</script>


<style lang="scss" scoped>
    @import '../styles/material-dashboard/variables.scss';

    html, body {
        font-family: 'Open Sans', serif;
        font-size: $font-size-default;
        font-weight: 300;
    }

    .hero.is-success {
        background: #F2F6FA;
    }

    .hero .nav, .hero.is-success .nav {
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    .dark-color {
        color: #363636;
        font-weight: unset
    }

    .small-label {
        font-size: $font-size-small;
    }

    .avatar {
        margin-top: 80px;
        padding-bottom: 20px;
    }

    @media screen and (max-width: 1599px) {
        .avatar img {
            max-height: 50px;
        }
    }

    @media screen and (min-width: 1025px) {
        .avatar img {
            padding: 5px;
            padding-left: 30px;
            max-height: 90px;
        }
    }

    input {
        font-weight: 300;
    }

    p {
        font-weight: 700;
    }

    p.subtitle {
        text-align: center
    }

    .login-wrap {
        background-color: $white;
    }

    .login-container {
        background-color: $red;
    }

    .login-heading,
    .login-content,
    .login-footer {
        margin-left: auto;
        margin-right: auto;
        width: 90%;
        max-width: 520px;
    }

    .login-content {
        background-color: white;
        padding: 50px 50px 30px;
        border-radius: $border-radius-base;
        border: 1px solid $border-radius-base;
    }

    .v-input.login-text-input /deep/ .v-input__slot {
        border-radius: 15px;
        min-height: auto;
    }

    .login-heading {
        padding-top: 15vh;
    }

    .login-footer {
        padding: 30px 50px;

        color: white;
        text-align: center;

        p {
            font-size: $font-size-small;
            font-weight: normal;
        }
    }

    .login-actions {
        padding-top: 30px;
        text-align: center;
    }

    .login-links {
        margin-top: 30px;
        text-align: center;
    }

    .link-sepa {
        font-weight: bold;
        margin-left: 5px;
        margin-right: 5px;

        &:before {
            content: '\00B7';
        }
    }

    .v-input--checkbox.v-input--has-state.error--text {
        + div {
            color: $red;
        }
    }

    .text-center {
        text-align: center;
    }
</style>